import { useI18n } from '@change-corgi/core/react/i18n';

import { useModalConfirmationContext } from 'src/app/shared/components/payments';

type Result = ModelHookResult<
	{
		title: string;
		text: string;
		cancelLabel: string;
		confirmLabel: string;
		showOverwritePaymentMethodModal: boolean;
	},
	{
		confirmPaymentMethodOverwrite: () => void;
		cancelPaymentMethodOverwrite: () => void;
	}
>;

export function useOverwritePaymentMethodConfirmationModal(): Result {
	const { translate } = useI18n();
	const [{ modalOptions }, { handleModalResult }] = useModalConfirmationContext();

	return {
		data: {
			title: translate('fe.components.payments.replace_confirmation.title'),
			text: translate('fe.components.payments.replace_confirmation.body'),
			confirmLabel: translate('fe.components.payments.replace_confirmation.confirm_replace'),
			cancelLabel: translate('fe.components.payments.replace_confirmation.cancel'),
			showOverwritePaymentMethodModal: modalOptions?.type === 'overwritePaymentMethod',
		},
		actions: {
			confirmPaymentMethodOverwrite: () => handleModalResult(true),
			cancelPaymentMethodOverwrite: () => handleModalResult(false),
		},
	};
}
